<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>
      <v-row>
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-title> Filtreleme </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row>
                    <v-col>
                        
                        <div class="d-flex justify-center">
                            <v-date-input
                             v-model="filter.date" 
                              label="Select range"
                              multiple="range"
                            ></v-date-input>
                          </div>
                 </v-col>
                    <v-col><v-text-field v-model="filter.customer"  placeholder="Cari Bilgisi"  hide-details ></v-text-field></v-col>
                    <v-col><v-text-field v-model="filter.seller"  placeholder="Şube"  hide-details ></v-text-field></v-col>
                    <v-col><v-text-field v-model="filter.price"  placeholder="Tutar"  hide-details ></v-text-field></v-col>
                    <v-col><v-text-field v-model="filter.serial"  placeholder="Seri No"  hide-details ></v-text-field></v-col>
                    <v-col><v-btn class="text-none mb-4"   color="indigo-darken-3"   @click="dialog = false">Filtrele</v-btn></v-col>
                </v-row>
 
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="saleList"
            v-model:options="options"
            :server-items-length="totalItems"
            :loading="loading"
            :search="search"
            :items-per-page="10"
            :items-per-page-options="[10, 25, 50, 100]"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
              'items-per-page-text': 'Sayfa başına kayıt',
              'page-text': '{0}-{1} / {2}',
            }"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Mağaza Satışları</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Ara..."
                  class="mx-4"
                  solo
                  clearable
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td style="width: 20%">{{ item.customer_match.customer.fullname }}</td>
                <td style="width: 10%;text-align: end;color:#f00">{{ formatCurrency(item.price) }}  ₺</td>
                <td style="width: 20%">{{ item.sale_personnel == null ? 'Bulunamadı'  : item.sale_personnel.name }}</td>
                <td style="width: 5%">
                  <v-btn
                    style="width: 30px; height: 30px"
                    icon
                    @click="showSerialNumbers(item.serial_numbers)"
                  >
                    <v-icon style="font-size: small">mdi-eye</v-icon>
                    <!-- Buton ikonu -->
                  </v-btn>
                </td>
                <td style="width: 10%">
                  <v-chip color="red">
                    {{ mapStatus(item.status) }}
                  </v-chip>
                </td>
              </tr>
            </template>
          </v-data-table>


                <!-- Dialog -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Seri Numaraları</span>
          </v-card-title>
          <v-card-text>
            <ul>
              <li v-for="serial in serialNumbers" :key="serial">{{ serial }}</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialog = false">Kapat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import { mapState } from "vuex";

import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar

export default {
  name: "SaleList",
  components: {
    MainLayout,
  },
  created() {
    this.fetchSaleList();
    const token = localStorage.getItem("user");
    this.seller_id = JSON.parse(token).seller_id;
  },
  data() {
    return {
      dialog: false, // Dialog durumu
      serialNumbers: [], // Seri numaralarını tutacak dizi
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Satış İşlemleri",
          disabled: false,
          href: "",
        },
      ],
      filter: {
        date: null,
        customer: "",
        seller: "",
        price: "",
        serial: "",
      },
      seller_id: "",
      totalItems: 3000,
      options: {
        page: 1,
        itemsPerPage: 10, // Varsayılan sayfa başına kayıt sayısı
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
      },
      headers: [
        { title: "Cari Bilgisi", value: "serial_number" },
        { title: "Toplam Tutar", value: "" },
        { title: "Satış Personeli", value: "" },
        { title: "Ürünler", value: "" },
        { title: "Durumu", value: "" },
        { title: "İşlemler", value: "actions", sortable: false, align: "end" }, // Aksiyonlar için
      ],
      select: { name: "Seçiniz", id: "0" },
      saleList: [],
      loading: false, // Yükleniyor durumu
      search: "", // Arama metni

      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
    };
  },

  computed: {
    ...mapState(["Sale"]), // Vuex state'inden SerialNumber'ı al
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    mapStatus(status) {
      const statusMap = {
        pending: "Beklemede",
        complete: "Tamamlandı",
        cancelled: "İptal Edildi",
        // Diğer durumlar...
      };
      return statusMap[status] || status; // Eğer durum haritada yoksa orijinal durumu döndür
    },
    showSerialNumbers(serialNumbers) {
      this.serialNumbers = serialNumbers; // Seçilen seri numaralarını ayarla
      this.dialog = true; // Dialog'u aç
    },

    fetchSaleList() {
      this.loading = true;
      const page = this.options.page || 1;
      const limit = this.options.itemsPerPage || 50;
      const start = (page - 1) * limit;
      mainService
        .list("sale", {
          start: start,
          limit: limit,
        })
        .then((response) => {
          if (response && response.data) {
            this.saleList = response.data;
            console.log('dd',this.saleList);
            this.totalItems = response.total;
          } else {
            console.error("Invalid response format:", response);
          }
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async approved(id, status) {
      const { value: confirmDelete } = await Swal.fire({
        title: "Onaylamak istediğinize emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, Devam Et!",
        cancelButtonText: "Hayır, iptal et!",
      });

      if (confirmDelete) {
        try {
          const response = await mainService.delete(id, status); // Kullanıcıyı silmek için servisi çağır
          this.fetchTransferList(); // Kullanıcı listesini güncelle
          Swal.fire("Sonuç!", response, "success");
        } catch (error) {
          Swal.fire("Hata!", "Transfer Gerçekleşirken hata oluştu.", "error");
        }
      } else {
        Swal.fire(
          "İptal edildi",
          "Kullanıcı silme işlemi iptal edildi.",
          "info"
        );
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchSaleList();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
